import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDialog } from "@angular/material";
import * as moment from "moment";
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { AddOfframpBankDialog } from "./add-offramp-bank/add-offramp-bank.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-banks",
  templateUrl: "./offramp-banks.component.html",
  styleUrls: ["./offramp-banks.component.css"],
})
export class OfframpBanksComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oBanks: any = [];
  banks: any = [];
  searchValue: string = '';
  filter: any = {
    page: 1,
    limit: 100,
  };
  prev_disabled = true;
  next_disabled = false;

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit';
          editBtn.style.marginRight = '5px';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          const deleteBtn = document.createElement('button');
          deleteBtn.type = 'button';
          deleteBtn.className = 'btn btn-sm btn-danger';
          deleteBtn.title = 'Delete';
          deleteBtn.innerHTML = '<i class="fa fa-trash"></i>';
          deleteBtn.onclick = (e) => {
            e.stopPropagation();
            this.deleteRecord(element);
          };
          container.appendChild(deleteBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 110
      },
      { headerName: 'Bank Name', field: 'name', flex: 1.5 },
      { headerName: 'Account Number', field: 'acc_no', flex: 1.2 },
      { headerName: 'IFSC', field: 'ifsc', flex: 1 },
      { headerName: 'Holder Name', field: 'holder_name', flex: 1.5 },
      {
        headerName: 'CreatedAt',
        field: 'createdAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  applyFilter(filterValue) {
    this.searchValue = filterValue || '';
    this.filter.page = 1;
    this.getData();
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.filter.search = this.searchValue;
    this.offrampService.getAllOfframpBanks(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.banks = list;
      this.oBanks = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
      }

      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch offramp banks", defaults.notif);
    });
  }

  resetFilters() {
    this.filter = { page: 1, limit: 100 };
    this.searchValue = '';
    this.getData();
  }

  addNewRecord() {
    const newRecord = { name: '', acc_no: '', ifsc: '', holder_name: '' };

    const dialogRef = this.dialog.open(AddOfframpBankDialog, {
      width: '600px',
      data: { record: newRecord, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Offramp bank added successfully", defaults.notif);
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddOfframpBankDialog, {
      width: '600px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Offramp bank updated successfully", defaults.notif);
        this.getData();
      }
    });
  }

  deleteRecord(record: any) {
    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete this bank?`,
        buttonText: { ok: 'Yes', cancel: 'No' }
      }
    }).afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinnerService.show();
        this.offrampService.deleteOfframpBank({ _id: record._id, _csrf: this._csrf }).subscribe(
          (response: any) => {
            this.spinnerService.hide();
            if (response.status || response.success) {
              this.notifSer.success("Success", response.message || "Bank deleted successfully", defaults.notif);
              this.getData();
            } else {
              this.notifSer.error("Error", response.message || "Failed to delete bank", defaults.notif);
            }
          },
          (error) => {
            this.spinnerService.hide();
            this.notifSer.error("Error", (error.error && error.error.message) || "Failed to delete bank", defaults.notif);
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-banks/offramp-banks.component.ts